import { TranslateFn } from 'src/localization/translate'

import { VendorFieldError } from './vendorForm.validation'

/**
 * Map a validation error code to a user-facing message (the KYB
 * `kybInvalidMessage` pattern). Kept separate from the pure validator so the
 * codes stay framework-free and localization lives in one switch. The required
 * / format copy reuses the add form's existing, already-localized strings so
 * add and edit read identically.
 */
export function vendorFieldErrorMessage(
  translate: TranslateFn,
  code: VendorFieldError | undefined,
): string | undefined {
  switch (code) {
    case 'NAME_REQUIRED':
      return translate('Vendor name is required')
    case 'EMAIL_REQUIRED':
      return translate('Vendor email is required')
    case 'EMAIL_INVALID':
      return translate('Enter a valid email address')
    case 'PHONE_INVALID':
      return translate('Enter a valid phone number')
    case 'NAME_TOO_LONG':
      return translate('Vendor name must be 255 characters or fewer')
    case 'EMAIL_TOO_LONG':
      return translate('Vendor email must be 254 characters or fewer')
    case 'EXTERNAL_ID_TOO_LONG':
      return translate('Vendor ID must be 255 characters or fewer')
    case 'CONTACT_NAME_TOO_LONG':
      return translate('Contact name must be 255 characters or fewer')
    case 'NOTES_TOO_LONG':
      return translate('Vendor description must be 1000 characters or fewer')
    default:
      return undefined
  }
}
